<template>
  <div>
    <md-content class="row">
      <div class="col-md-5 col-sm-12 button-fixed" data-cy="cookieBanner">
        <div class="p-3 pb-4 bg-custom text-white">
          <div class="row">
            <div class="col-10">
              <div class="h4 text-danger bold cookies-title">
                Cookies & Privacy
              </div>
            </div>
          </div>
          <p class="h5 text-white explanation-text">
            By clicking OK you acknowledge our use of cookies and consent to their use to collect
            data which helps us to improve our site.
          </p>
          <div class="text-right inline-items content-accept-cookies">
            <a
              href="https://www.iubenda.com/privacy-policy/43113518/full-legal"
              class="info col-6"
              target="_blank"
              rel="noopener"
            >
              More information
            </a>
            <SButtonMaterial
              class="col-3 mb-0 accept-cookies"
              buttonType="button"
              color="danger"
              textColor="white"
              materialClass="dense"
              text="OK"
              data-cy="acceptCookies"
              @button="checkCookiesAndPrivacy"
            />
          </div>
        </div>
      </div>
    </md-content>
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
export default {
  mixins: [UserHelperVue],
  components: {
    SButtonMaterial,
  },
  methods: {
    checkCookiesAndPrivacy() {
      localStorage.setItem("cookies_privacy", true);
      this.$emit("cookies-privacy", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-custom {
  background-color: $secondary;
}
.button-fixed {
  bottom: 20px;
  position: fixed;
  right: 0;
  border-radius: 10px;
  z-index: 2001 !important;
}
.fas {
  cursor: pointer;
  font-size: 24px;
}
.info {

font-weight: bold;
font-size:  18px;
line-height: 16px;
letter-spacing: 1.25px;
color: $white !important;
}
.cookies-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: #f5bfb3 !important;
}
.explanation-text {
  margin-top: 0.8rem;
  line-height: 18px;
  letter-spacing: 1.25px;
  font-weight: normal;
}
.accept-cookies {
  height: 40px !important;
  font-size: 14px !important;
}
.content-accept-cookies {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
